import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { Globals } from '../../../globals';
import { DishServices } from '../../dish/services';
import { Uploads } from '../../services/uploads';
import { ProductsServices } from '../../products/services';
import { HttpClient } from '@angular/common/http';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { getCurrencySymbol } from '@angular/common';
import { DishViewLabelPage } from '../../dish/dish-view/dish-view-label/dish-view-label';
import { TranslateService } from '@ngx-translate/core';
import { StaticsServices } from '../../services/statics';
import { DishCreateNamePage } from '../../dish/dish-create/dish-create-name/dish-create-name';
import { DishCreateAllergensPage } from '../../dish/dish-create/dish-create-allergens/dish-create-allergens';
import { DishCreatePricePage } from '../../dish/dish-create/dish-create-price/dish-create-price';
import { ProductCreateWfoodcostPricePage } from '../../products/product-create/product-create-without-foodcost/product-create-wfoodcost-price/product-create-wfoodcost-price';
import { ProductCreateWfoodcostAllergensPage } from '../../products/product-create/product-create-without-foodcost/product-create-wfoodcost-allergens/product-create-wfoodcost-allergens';
import { ProductCreateFoodcostInfoPage } from '../../products/product-create/product-create-foodcost/product-create-foodcost-info/product-create-foodcost-info';
import { ProductCreateWfoodcostInfoPage } from '../../products/product-create/product-create-without-foodcost/product-create-wfoodcost-info/product-create-wfoodcost-info';
import { ArticlesServices } from '../services';
import { ProductCreateWfoodcostSelectProviderPage } from '../../products/product-create/product-create-without-foodcost/product-create-wfoodcost-select-provider/product-create-wfoodcost-select-provider';
import { AnalyticsServices } from '../../services/analyticsServices';
import * as firebase from 'firebase';
import { IngredientsServices } from '../../ingredients/services';
import { DeliberyNoteViewPage } from '../../delibery_note/delibery-note-view/delibery-note-view/delibery-note-view';
import { ProviderOrderCartPage } from '../../providers/orders/provider-order-cart/provider-order-cart';
import { ProvidersServices } from '../../providers/services';

/**
 * Generated class for the ArticleViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-article-view',
    templateUrl: 'article-view.html',
})
export class ArticleViewPage {

    article_type: string = '';
    article_uid: string = '';
    article: any = Array();
    valueChanges: any;
    article_name: string = '';
    article_description: string = '';
    article_pvp: number = 0;
    article_pvp2: number = 0;
    article_pvp3: number = 0;
    article_pvp_tk: number = 0;
    colors: any = Array();
    article_sub_recipe_type: boolean = true;
    _object: any;
    loader_deliveries: boolean = false;
    total_5_deliveries: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        private alertCtrl: AlertController,
        public dishServices: DishServices,
        public uploadServices: Uploads,
        public toastCtrl: ToastController,
        public productsServices: ProductsServices,
        public translate: TranslateService,
        public ingredientsServices: IngredientsServices,
        public staticsServices: StaticsServices,
        private http: HttpClient,
        public articlesServices: ArticlesServices,
        private analyticsServices: AnalyticsServices,
        public providersServices: ProvidersServices) {
        this.colors = this.globals.getColorsElements();
        //Si venimos de crear un elemento, eliminamos todas las views de creacion, para el momento de hacer pop, vaya al listado
        if (this.navCtrl.getViews().length === 6) {
            this.navCtrl.remove(5);
            this.navCtrl.remove(4);
            this.navCtrl.remove(3);
            this.navCtrl.remove(2);
            this.navCtrl.remove(1);
        }

        this.article_type = this.navParams.get('article_type');
        this.article_uid = this.navParams.get('article_uid');
    }

    async ionViewWillEnter() {
        this.FindLots();

        this.article_type = this.navParams.get('article_type');
        this.article_uid = this.navParams.get('article_uid');

        if (this.valueChanges) {
            this.valueChanges.unsubscribe();
            this.valueChanges = null; // Asegurar que se reinicia la referencia
        }

        if (this.article_type === 'dish') {
            this.globals.GAtrackView('Dish', 'Dish - View', this.globals.restaurant.email, 'View', 'View dish', 'Dish', '');
            //
            this.dishServices.dishDoc = this.dishServices.afs.doc('dish/' + this.article_uid); //Recuperamos el plato para tener el plato simpre actulizado.
            this.valueChanges = this.dishServices.dishDoc.valueChanges().subscribe(value => {
                var get_image = true;
                if (value.image == '') {
                    get_image = false;
                }
                value.UID = this.article_uid;
                //order tags
                value.tags = this.globals.orderNamesByAlphabetical(value.tags);
                //check actives
                if (value.tpv_active == undefined) {
                    value.tpv_active = true;
                }
                if (value.pos_favourite == undefined) {
                    value.pos_favourite = false;
                }
                //check prices
                value.price = this.globals.ifVarisFiniteOrNaN(value.price);
                value.price_half = this.globals.ifVarisFiniteOrNaN(value.price_half);
                value.price_tapa = this.globals.ifVarisFiniteOrNaN(value.price_tapa);
                //
                this.article = value;
                if (typeof this.article.created_at === 'string') {
                    // Convertir la cadena a objeto Date
                    this.article.created_at = firebase.firestore.Timestamp.fromDate(new Date(this.article.created_at));
                }
                //init manual data
                this.article.type = this.article_type;
                this.article_name = this.globals.nameLangSelectDish(this.article);
                this.article_description = this.globals.descriptionLangSelectArticle(this.article);
                this.article_pvp = this.article.price;
                this.article_pvp2 = this.article.price_half;
                this.article_pvp3 = this.article.price_tapa;
                this.article_pvp_tk = this.article.price_takeaway === undefined ? 0 : this.article.price_takeaway;
                //get n load image
                if (get_image) {
                    if (this.dishServices.image_url_dish_view == undefined || value.image != this.dishServices.dish_tmp.image) {
                        this.getDishImageUrl(this.article.image);//Get url from image
                    }
                } else {
                    this.dishServices.image_url_dish_view = null;
                }
                //insert value a dish_tmp
                this.dishServices.dish_tmp = value;
            });
        } else if (this.article_type === 'product') {
            this.globals.GAtrackView('Products', 'Products - View', this.globals.restaurant.email, 'View', 'View product', 'Products', '');
            //
            this.productsServices.productDoc = this.productsServices.afs.doc('products/' + this.article_uid); //Recuperamos el ingrediente para tener el plato simpre actulizado.
            this.valueChanges = this.productsServices.productDoc.valueChanges().subscribe(value => {
                var get_image = true;
                if (value.image == '') {
                    get_image = false;
                }
                value.UID = this.article_uid;
                //order tags
                value.tags = this.globals.orderNamesByAlphabetical(value.tags);
                //check actives
                if (value.tpv_active == undefined) {
                    value.tpv_active = true;
                }
                if (value.pos_favourite == undefined) {
                    value.pos_favourite = false;
                }
                //check prices
                value.pvp = this.globals.ifVarisFiniteOrNaN(value.pvp);
                value.pvp2 = this.globals.ifVarisFiniteOrNaN(value.pvp2);
                value.pvp3 = this.globals.ifVarisFiniteOrNaN(value.pvp3);
                //
                this.article = value;
                if (typeof this.article.created_at === 'string') {
                    // Convertir la cadena a objeto Date
                    this.article.created_at = firebase.firestore.Timestamp.fromDate(new Date(this.article.created_at));
                }
                //init manual data
                this.article.type = this.article_type;
                this.article_name = this.globals.nameLangSelectProduct(this.article);
                this.article_description = this.globals.descriptionLangSelectArticle(this.article);
                this.article_pvp = this.article.pvp;
                this.article_pvp2 = this.article.pvp2;
                this.article_pvp3 = this.article.pvp3;
                this.article_pvp_tk = this.article.pvp_takeaway === undefined ? 0 : this.article.pvp_takeaway;
                //get n load image
                if (get_image) {
                    if (this.productsServices.image_url_product_view == undefined || value.image != this.productsServices.product_tmp.image) {
                        this.getProductImageUrl(this.article.image);//Get url from image
                    }
                } else {
                    this.productsServices.image_url_product_view = null;
                }
                //insert value a dish_tmp
                this.productsServices.product_tmp = value;
                //comprovar que tenga providers
                if (!this.article.providers && !value.sub_recipe) {
                    this.editProviders();
                }
            });
        }
    }

    ionViewDidLeave() {
        if (this.valueChanges) {
            this.valueChanges.unsubscribe();
            this.valueChanges = null; // Asegurar que se reinicia la referencia
        }
    }

    getDishImageUrl(image_ref) {
        //Get image url for show. Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
        this.dishServices.image_url_dish_view = null;
        if (image_ref) {
            const ref = this.uploadServices.storage.ref(image_ref);
            this.dishServices.image_url_dish_view = ref.getDownloadURL();
        }
    }

    getProductImageUrl(image_ref) {
        //Get image url for show. Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
        this.productsServices.image_url_product_view = null;
        if (image_ref) {
            const ref = this.uploadServices.storage.ref(image_ref);
            this.productsServices.image_url_product_view = ref.getDownloadURL();
        }

    }

    // cambiar tipo de articulo
    async ChangeTypeArticle() {
        let _object

        _object = this.article;


        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-atencion'),
            message: this.translate.instant('articles-seguro-quieres-seguir'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {

                        // cambiar de producto a plato
                        if (this.article_type === "product") {

                            if (_object && (_object.sub_recipe === false || _object.sub_recipe === undefined)) {

                                this.dishServices.afs.collection('dish').add({
                                    'UID_RESTAURANT': this.globals.restaurant_uid,
                                    'allergens': _object.allergens,
                                    'aiAttempts': _object.aiAttempts || 0,
                                    'created_at': _object.created_at,
                                    'name_es': _object.name,
                                    'name_en': _object.name_en,
                                    'name_fr': _object.name_fr,
                                    'name_it': _object.name_it,
                                    'name_de': _object.name_de,
                                    'name_ca': _object.name_ca,
                                    'description_es': _object.description_es,
                                    'description_en': _object.description_en,
                                    'description_fr': _object.description_fr,
                                    'description_it': _object.description_it,
                                    'description_de': _object.description_de,
                                    'description_ca': _object.description_ca,
                                    'ean': _object.ean || "",
                                    'reference': _object.reference || "",
                                    'image': _object.image || "",
                                    'foodcost_static': 0,
                                    'foodcost_parts': 1,
                                    'observations': _object.observations || "",
                                    'pos_background_color': _object.pos_background_color || "",
                                    'pos_border_color': _object.pos_border_color || "",
                                    'pos_color_name': _object.pos_color_name || "",
                                    'pos_favourite': _object.pos_favourite || false,
                                    'price': _object.pvp || 0,
                                    'price_half': _object.pvp2 || 0,
                                    'price_tapa': _object.pvp3 || 0,
                                    'price_takeaway': _object.pvp_takeaway || 0,
                                    'price_combo_extra': _object.pvp_combo_extra || 0,
                                    'price_supplement': _object.pvp_supplement || 0,
                                    'tags': _object.tags || [],
                                    'tags_static': _object.tags_static || "",
                                    'tax': _object.tax || this.globals.RESTAURANT_TAX,
                                    'tk_active': _object.tk_active || false,
                                    'tpv_active': _object.tpv_active || true,
                                    'updated_user': _object.updated_user || "",
                                    'variations_favourite': _object.variations_favourite || [],
                                    'recipe': _object.recipe || "",
                                    'time': "",
                                    'tools': "",
                                    'time_cooking': "",
                                    'difficulty': "",
                                    'type_unit': _object.type_unit || 'ud',
                                    'foodcost': Array(),
                                    'updated_at': new Date(),
                                }).then(doc => {
                                    // Añadir tags nuevos al array global
                                    if (_object.tags && _object.tags.length > 0) {
                                        this.globals.addTagsToGlobal(_object.tags);
                                    }
                                    //this.analyticsServices.trackingExpArticles('create dish', this.globals.tracking_exp['create_article'], doc.id);
                                    //Get the UID Document
                                    this.valueChanges.unsubscribe();

                                    //delete from list
                                    this.articlesServices.list_dishes_products_array.splice(this.articlesServices.list_dishes_products_array.findIndex(item => item.UID == this.article_uid && item.type === this.article_type), 1);
                                    this.articlesServices.list_dishes_products_array = [...this.articlesServices.list_dishes_products_array];

                                    this.articlesServices.articles_array_filtered.splice(this.articlesServices.articles_array_filtered.findIndex(item => item.UID == this.article_uid && item.type === this.article_type), 1);
                                    this.articlesServices.articles_array_filtered = [...this.articlesServices.articles_array_filtered];

                                    this.deletesAndStaticsProduct(this.article_uid);

                                    this.productsServices.delete(this.article_uid)

                                    this.navCtrl.pop().then(() => {
                                        this.navCtrl.push(ArticleViewPage, {
                                            article_uid: doc.id,
                                            article_type: 'dish'
                                        })
                                    });

                                });

                            }
                            else {
                                // to simple product
                                if (this.article.providers) {
                                    this.ingredientsServices.afs.collection('products').doc(this.article_uid).update({
                                        'sub_recipe': false,
                                    });
                                } else {
                                    this.ingredientsServices.afs.collection('products').doc(this.article_uid).update({
                                        'providers': [],
                                        'provider_static': "",
                                        'sub_recipe': false,
                                    });
                                    //this.editProviders();
                                }
                                this.valueChanges.unsubscribe();
                                // this.navCtrl.setRoot(ArticleViewPage, {
                                //     article_uid: this.article_uid,
                                //     article_type: 'product'
                                // });


                                this.navCtrl.pop().then(() => {
                                    this.navCtrl.push(ArticleViewPage, {
                                        article_uid: this.article_uid,
                                        article_type: 'product'
                                    })
                                });
                            }
                        }
                        else {

                            // cambiar de plato a producto simple
                            if (_object) {

                                this.productsServices.afs.collection('products').add({

                                    'UID_RESTAURANT': this.globals.restaurant_uid,
                                    'allergens': _object.allergens || [],
                                    'aiAttempts': _object.aiAttempts || 0,
                                    'created_at': _object.created_at,
                                    'name': _object.name_es,
                                    'name_en': _object.name_en,
                                    'name_fr': _object.name_fr,
                                    'name_it': _object.name_it,
                                    'name_de': _object.name_de,
                                    'name_ca': _object.name_ca,
                                    'description_es': _object.description_es,
                                    'description_en': _object.description_en,
                                    'description_fr': _object.description_fr,
                                    'description_it': _object.description_it,
                                    'description_de': _object.description_de,
                                    'description_ca': _object.description_ca,
                                    'ean': _object.ean || "",
                                    'reference': _object.reference || "",
                                    'image': _object.image || "",
                                    'featured': false,
                                    'measurement': "ud.",
                                    'observations': _object.observations || "",
                                    'pos_background_color': _object.pos_background_color || "",
                                    'pos_border_color': _object.pos_border_color || "",
                                    'pos_color_name': _object.pos_color_name || "",
                                    'pos_favourite': _object.pos_favourite || false,
                                    'price_static': 0,
                                    'provider_static': "",
                                    'providers': [],
                                    'pvp2': _object.price_half || 0,
                                    'pvp3': _object.price_tapa || 0,
                                    'pvp': _object.price || 0,
                                    'pvp_combo_extra': _object.price_combo_extra || 0,
                                    'pvp_supplement': _object.price_supplement || 0,
                                    'pvp_takeaway': _object.price_takeaway || 0,
                                    'ratelimit': 0,
                                    'stock': 0,
                                    'stock_alert': 0,
                                    'stock_max': 0,
                                    'sub_recipe': false,
                                    'tags': _object.tags || [],
                                    'tags_static': _object.tags_static || "",
                                    'tax': _object.tax || this.globals.RESTAURANT_TAX,
                                    'tk_active': _object.tk_active || false,
                                    'tpv_active': _object.tpv_active || true,
                                    'updated_user': _object.updated_user || "",
                                    'variations_favourite': _object.variations_favourite || [],
                                    'updated_at': new Date(),

                                }).then(doc => {
                                    // Añadir tags nuevos al array global
                                    if (_object.tags && _object.tags.length > 0) {
                                        this.globals.addTagsToGlobal(_object.tags);
                                    }
                                    //   this.globals.GAtrackView('Dish', 'Dish - Name - Create', this.globals.restaurant.email, 'Create/Update', 'Create name', 'Dish', this.dishServices.form.value.name_es);
                                    //this.analyticsServices.trackingExpArticles('create product', this.globals.tracking_exp['create_article'], doc.id);
                                    //Get the UID Document

                                    this.valueChanges.unsubscribe();

                                    //delete from list
                                    this.articlesServices.list_dishes_products_array.splice(this.articlesServices.list_dishes_products_array.findIndex(item => item.UID == this.article_uid && item.type === this.article_type), 1);
                                    this.articlesServices.list_dishes_products_array = [...this.articlesServices.list_dishes_products_array];

                                    this.articlesServices.articles_array_filtered.splice(this.articlesServices.articles_array_filtered.findIndex(item => item.UID == this.article_uid && item.type === this.article_type), 1);
                                    this.articlesServices.articles_array_filtered = [...this.articlesServices.articles_array_filtered];
                                    this.deletesAndStaticsDish(this.article_uid);

                                    this.dishServices.delete(this.article_uid)

                                    this.navCtrl.pop().then(() => {
                                        this.navCtrl.push(ArticleViewPage, {
                                            article_uid: doc.id,
                                            article_type: 'product'
                                        })

                                    });

                                });
                            }
                        }
                    }
                }
            ]
        });
        alert.present();


    }

    editBasicInfo() {
        if (this.article_type === 'dish') {
            this.navCtrl.push(DishCreateNamePage, {
                update: true,
                dish_uid: this.article.UID,
                name: this.article.name_es,
                name_en: this.article.name_en,
                name_fr: this.article.name_fr,
                name_it: this.article.name_it,
                name_de: this.article.name_de,
                name_ca: this.article.name_ca,
                tags: this.article.tags,
                description_es: this.article.description_es,
                description_en: this.article.description_en,
                description_fr: this.article.description_fr,
                description_it: this.article.description_it,
                description_de: this.article.description_de,
                description_ca: this.article.description_ca,
                dish: this.article
            });
        } else {
            if (this.article.sub_recipe) {
                this.navCtrl.push(ProductCreateFoodcostInfoPage, {
                    update_state: true,
                    product_uid: this.article.UID,
                    product_name: this.article.name,
                    name_en: this.article.name_en,
                    name_fr: this.article.name_fr,
                    name_it: this.article.name_it,
                    name_de: this.article.name_de,
                    name_ca: this.article.name_ca,
                    measurement: this.article.measurement,
                    stock: this.article.stock,
                    stock_alert: this.article.stock_alert,
                    stock_max: this.article.stock_max,
                    tags: this.article.tags,
                    description_es: this.article.description_es,
                    description_en: this.article.description_en,
                    description_fr: this.article.description_fr,
                    description_it: this.article.description_it,
                    description_de: this.article.description_de,
                    description_ca: this.article.description_ca,
                    product: this.article
                })
            } else {
                this.navCtrl.push(ProductCreateWfoodcostInfoPage, {
                    update_state: true,
                    product_uid: this.article.UID,
                    product_name: this.article.name,
                    name_en: this.article.name_en,
                    name_fr: this.article.name_fr,
                    name_it: this.article.name_it,
                    name_de: this.article.name_de,
                    name_ca: this.article.name_ca,
                    measurement: this.article.measurement,
                    stock: this.article.stock,
                    stock_alert: this.article.stock_alert,
                    stock_max: this.article.stock_max,
                    tags: this.article.tags,
                    pvp: this.article.pvp,
                    description_es: this.article.description_es,
                    description_en: this.article.description_en,
                    description_fr: this.article.description_fr,
                    description_it: this.article.description_it,
                    description_de: this.article.description_de,
                    description_ca: this.article.description_ca,
                    product: this.article
                })
            }
        }
    }




    editAllergens() {
        if (this.article_type === 'dish') {
            this.navCtrl.push(DishCreateAllergensPage, {
                update: true,
                dish_uid: this.article.UID,
                allergens: this.article.allergens,
                dish_name: this.globals.nameLangSelectDish(this.article),
                dish: this.article,
                article_type: this.article_type,
                article_uid: this.article_uid

            });
        } else {
            this.navCtrl.push(ProductCreateWfoodcostAllergensPage, {
                update_state: true,
                product_uid: this.article.UID,
                allergens: this.article.allergens,
                product_name: this.globals.nameLangSelectProduct(this.article),
                product: this.article,
                article_type: this.article_type,
                article_uid: this.article_uid
            });
        }
    }

    editSalesInfo() {
        if (this.article_type === 'dish') {
            this.navCtrl.push(DishCreatePricePage, {
                update: true,
                dish_uid: this.article.UID,
                price: this.article.price,
                price_half: this.article.price_half,
                price_tapa: this.article.price_tapa,
                price_supplement: this.article.price_supplement,
                price_combo_extra: this.article.price_combo_extra,
                price_takeaway: this.article.price_takeaway,
                dish_name: this.globals.nameLangSelectDish(this.article),
                dish: this.article,
                ean: this.article.ean,
                reference: this.article.reference
            });
        } else {
            this.navCtrl.push(ProductCreateWfoodcostPricePage, {
                update_state: true,
                product_uid: this.article.UID,
                product_name: this.globals.nameLangSelectProduct(this.article),
                pvp: this.article.pvp,
                pvp2: this.article.pvp2,
                pvp3: this.article.pvp3,
                pvp_supplement: this.article.pvp_supplement,
                pvp_combo_extra: this.article.pvp_combo_extra,
                pvp_takeaway: this.article.pvp_takeaway,
                ean: this.article.ean,
                product: this.article,
                reference: this.article.reference

            });
        }
    }

    //
    async togglePosActive() {
        var collection = 'dish';
        if (this.article_type === 'product') {
            collection = 'products';
        }
        this.dishServices.afs.collection(collection).doc(this.article_uid).update({
            'tpv_active': !this.article.tpv_active,
            'updated_at': new Date(),
            'updated_user': this.globals.user_name
        });
    }

    async togglePosFavourite() {
        var collection = 'dish';
        if (this.article_type === 'product') {
            collection = 'products';
        }
        this.dishServices.afs.collection(collection).doc(this.article_uid).update({
            'pos_favourite': !this.article.pos_favourite,
            'updated_at': new Date(),
            'updated_user': this.globals.user_name
        });
    }


    async printFull() {
        this.globals.GAtrackView('Dish', 'Dish - Full - Print', this.globals.restaurant.email, 'View', 'Print full', 'Dish', this.article_name);

        if (this.globals.checkLimitsByLicense('dishes', 'print')) {//version pro abierto

            let loadingPopup = this.loadingCtrl.create({
                spinner: 'crescent',
                content: ''
            });
            loadingPopup.present();

            //Format values
            var dish_image;

            if (!this.dishServices.image_url_dish_view) {
                dish_image = '';
            } else {
                await this.dishServices.image_url_dish_view.subscribe(data => {
                    dish_image = data;
                });
            }

            var _currency = getCurrencySymbol(this.globals.user_currency, 'narrow', 'es');
            var currency = _currency;
            //Format object menu for POST send
            var dish_send = this.dishServices.dish_tmp;


            this.http.post(this.globals.api_path + 'dish/print',
                {
                    dish: dish_send,
                    dish_image: dish_image,
                    company: this.globals.restaurant.company,
                    currency: currency,
                    lang: this.globals.restaurant.lang,
                    show_image: this.globals.checkLimitsByLicense('dishes', 'image'),
                    prices3: this.globals.checkLimitsByLicense('dishes', '3prices'),
                    watermark: this.globals.checkLimitsByLicense('dishes', 'watermark'),
                    show_ingredients: this.globals.checkLimitsByLicense('dishes', 'foodcost'),
                    show_recipe: this.globals.checkLimitsByLicense('dishes', 'recipe'),
                    show_nutrition: this.globals.checkLimitsByLicense('dishes', 'nutrition'),
                    show_indicators: this.globals.checkLimitsByLicense('dishes', 'indicators'),
                }
                , {})
                .subscribe(res => {
                    if (this.globals.so_mobile) {
                        window.location.assign(String(res['file']));
                    } else {
                        window.open(String(res['file']), '_blank');
                    }
                    loadingPopup.dismiss();
                }, error => {
                    loadingPopup.dismiss();
                });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    async printResume() {

        this.globals.GAtrackView('Dish', 'Dish - Sheet - Print', this.globals.restaurant.email, 'View', 'Print sheet', 'Dish', this.article_name);

        if (this.globals.checkLimitsByLicense('dishes', 'print')) {//version pro abierto
            let loadingPopup = this.loadingCtrl.create({
                spinner: 'crescent',
                content: ''
            });
            loadingPopup.present();

            //Format values
            var dish_image;

            if (!this.dishServices.image_url_dish_view) {
                dish_image = '';
            } else {
                await this.dishServices.image_url_dish_view.subscribe(data => {
                    dish_image = data;
                });
            }

            //Format object menu for POST send
            var dish_send = this.dishServices.dish_tmp;

            this.http.post(this.globals.api_path + 'dish/print1',
                {
                    dish: dish_send,
                    dish_image: dish_image,
                    company: this.globals.restaurant.company,
                    lang: this.globals.restaurant.lang,
                    show_image: this.globals.checkLimitsByLicense('dishes', 'image'),
                    prices3: this.globals.checkLimitsByLicense('dishes', '3prices'),
                    watermark: this.globals.checkLimitsByLicense('dishes', 'watermark'),
                    show_ingredients: this.globals.checkLimitsByLicense('dishes', 'foodcost'),
                    show_recipe: this.globals.checkLimitsByLicense('dishes', 'recipe'),
                    show_nutrition: this.globals.checkLimitsByLicense('dishes', 'nutrition'),
                    show_indicators: this.globals.checkLimitsByLicense('dishes', 'indicators'),
                }, {})
                .subscribe(res => {
                    if (this.globals.so_mobile) {
                        window.location.assign(String(res['file']));
                    } else {
                        window.open(String(res['file']), '_blank');
                    }
                    loadingPopup.dismiss();
                }, error => {
                    loadingPopup.dismiss();
                });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    printLabel() {
        if (this.globals.checkLimitsByLicense('dishes', 'print')) {
            this.navCtrl.push(DishViewLabelPage, {
                dish: this.article
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }


    delete() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-eliminar-articulo'),
            message: this.translate.instant('eliminar-articulo-desc'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.valueChanges.unsubscribe();
                        //delete from list
                        this.articlesServices.list_dishes_products_array.splice(this.articlesServices.list_dishes_products_array.findIndex(item => item.UID == this.article_uid && item.type === this.article_type), 1);
                        this.articlesServices.list_dishes_products_array = [...this.articlesServices.list_dishes_products_array];

                        this.articlesServices.articles_array_filtered.splice(this.articlesServices.articles_array_filtered.findIndex(item => item.UID == this.article_uid && item.type === this.article_type), 1);
                        this.articlesServices.articles_array_filtered = [...this.articlesServices.articles_array_filtered];
                        //delete by type
                        if (this.article_type === 'dish') {
                            this.analyticsServices.trackingExpArticles('delete dish', this.globals.tracking_exp['delete_article'], this.article_uid);
                            this.globals.GAtrackView('Dish', 'Dish - Delete', this.globals.restaurant.email, 'Delete', 'Delete dish', 'Dish', this.article_name);
                            this.deletesAndStaticsDish(this.article_uid);
                            this.dishServices.afs.doc('dish/' + this.article_uid).delete();
                        } else {
                            this.analyticsServices.trackingExpArticles('delete product', this.globals.tracking_exp['delete_article'], this.article_uid);
                            this.globals.GAtrackView('Products', 'Products - Delete', this.globals.restaurant.email, 'Delete', 'Delete product', 'Products', this.article_name);
                            this.deletesAndStaticsProduct(this.article_uid);
                            this.productsServices.afs.doc('products/' + this.article_uid).delete();
                        }
                        //return to list
                        this.navCtrl.popToRoot();
                    }
                }
            ]
        });
        alert.present();
    }

    async deletesAndStaticsDish(uid) {
        this.staticsServices.changeStateStaticWait(true);
        this.staticsServices.addDeleteStaticToQueue(uid, 'deletes_dish_update');
    }

    async deletesAndStaticsProduct(uid) {
        this.staticsServices.changeStateStaticWait(true);
        this.staticsServices.addDeleteStaticToQueue(uid, 'deletes_prod_update');
    }

    activeTab(article) {
        if (article.type === 'product' && article.sub_recipe) {
            let cssClasses = {
                //'active': false,
                'aria-expanded': false
            }
            return cssClasses;
        } else {
            let cssClasses = {
                //'active': true,
                'aria-expanded': true
            }
            return cssClasses;
        }
    }

    duplicate() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('articles-duplicar-articulo'),
            message: this.translate.instant('articles-seguro-quieres-duplicar-articulo'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.duplicateArticle();
                    }
                }
            ]
        });
        alert.present();
    }

    duplicateArticle() {
        this.articlesServices.duplicateArticle(this.article);
        let toast = this.toastCtrl.create({
            message: this.translate.instant('articles-duplicado-correctamente'),
            duration: 1000,
            position: 'top'
        });
        toast.present();
    }

    editProviders() {
        this.navCtrl.push(ProductCreateWfoodcostSelectProviderPage, {
            update_state: true,
            product_uid: this.article.UID,
            products: this.article,
            product_name: this.globals.nameLangSelectProduct(this.article),
            product_measurement: this.article.measurement,
            product: this.article
        });
    }

    // buscar els lots
    total_lotes: any = [];
    show_all_lotes: boolean = false;
    FindLots() {
        this.total_5_deliveries = [];
        if (this.article_type === "product") {
            this.http.post(this.globals.analytics_path + 'FindLots',
                {
                    uid_element: this.article_uid,
                    type_element: this.article_type,
                    uid_restuarant: this.globals.restaurant_uid
                }, {})
                .subscribe(res => {
                    this.total_lotes = res;
                    this.total_5_deliveries = this.total_lotes.slice(0, 5);
                    this.loader_deliveries = true;
                }, error => {
                    this.loader_deliveries = true;
                });
        }
    }

    change_show_lotes() {
        if (this.show_all_lotes) {
            this.show_all_lotes = false;
        } else {
            this.show_all_lotes = true;
        }
    }

    SerachDelibery(delivery_uid, element) {
        this.navCtrl.push(DeliberyNoteViewPage, {
            delibery_note_uid: delivery_uid,
        })
    }

    onSelectTab(selectedTab) {
        var tab_ative = document.getElementsByClassName('tab-pane') as HTMLCollectionOf<HTMLElement>;
        for (var i = 0, max = tab_ative.length; i < max; i++) {
            if (tab_ative[i] != undefined) {
                tab_ative[i].classList.remove('active');
            }
        }
        var doc = document.getElementById(selectedTab);
        doc.classList.add('active');
    }

    openCart() {
        if (this.globals.checkLimitsByLicense('stock', 'pedidos')) {
            this.providersServices.getTotalCartElements(this.globals.restaurant_uid, this.globals.user_uid);
            this.navCtrl.push(ProviderOrderCartPage);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
        this.globals.open_side_menu = false;
    }
}


// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view.ts